import type { ExtendedWord } from '../types';
import type { SupportedLanguage } from '../i18n';

/**
 * Normalize a language code to the short form used by audio directories.
 * i18next may return region-qualified codes (e.g. "he-IL", "en-US") even when
 * `load: 'languageOnly'` is configured — for example before initialization
 * completes or on certain native WebViews. Audio files live under `he/` and
 * `en/`, so we always strip the region suffix.
 */
export function toAudioLang(language: string): string {
  return language.split('-')[0];
}

/**
 * Get the display word based on current language
 * Returns Hebrew word for 'he', English word for 'en' (with fallback to transliteration)
 */
export function getDisplayWord(word: ExtendedWord, language: SupportedLanguage): string {
  if (language === 'he') {
    return word.hebrewWord;
  }
  // For English, use englishWord if available, otherwise transliteration
  return word.englishWord || word.transliteration;
}

/**
 * Get the audio file path for a word based on language
 */
export function getWordAudioPath(word: ExtendedWord, language: SupportedLanguage): string {
  const audioName = word.englishWord?.toLowerCase() || word.transliteration.toLowerCase();
  return `/audio/words/${toAudioLang(language)}/${audioName}.mp3`;
}
